import axios from "axios";
import {
  getHeaders,
  checkStatus,
} from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;

export async function getProject(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Get`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getProjectList(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/List`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getProjectTaskList(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Task/List`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function taskTask(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Task/delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addProjectTask(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Task/Save`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getProjectModule(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Module`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getProjectSubModule(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/SubModule`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getProjectSegment(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Segment`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ClientsList(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Clients`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ProjectAddUpdate(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Save`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function DeleteProject(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Project/delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getModuleList(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Module`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addModule(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Module/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteModule(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Module/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addSubModule(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/SubModule/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteSubModule(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/SubModule/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getSubModuleList(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/SubModule`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getSegmentList(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Segment`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addSegment(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Segment/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteSegment(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Segment/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addProjectDoc(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Doc/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteProjectDoc(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Doc/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addTaskDoc(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Task/Doc/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteTaskDoc(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/TaskDoc/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function projectStatusUpdate(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Project/Status/Update`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addProjectTeamMember(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Member/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function removeProjectTeamMember(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Member/Remove`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function TaskSummary(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Task/Summary`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteTask(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Task/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function ClientAddUpdate(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Client/Save`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function TaskAddComment(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Task/AddComment`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function TaskCommentList(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Comment/List`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function TaskDocDelete(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Task/Doc/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getActionItems(params) {
  try {
    const response = await axiosInstance.get(
      `${baseURL}/Master/ActionItems`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function SendClientEmail(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/SendClientEmail?clientId=${params.clientId}`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function sendProjectEmail(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/SendProjectEmail?projectId=${params.projectId}`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addProjectSprint(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Sprint/Save`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function moveTOSprintTask(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Sprint/Task/Move`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteSprintTask(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Sprint/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function sprintUpdateStatus(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Sprint/Status/Update`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}




export async function sprintActiveStatus() {
  try {
    const response = await axiosInstance.get(
      `${baseURL}/Project/Sprint/Active`,
      {
        headers: await getHeaders(),
        body: JSON.stringify({}),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addProjectNote(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Note/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify({}),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteProjectNote(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/Note/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export async function addProjectSaveMilestoneMaster(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/SaveMilestoneMaster`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export async function addProjectSaveMilestoneMapping(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/SaveMilestoneMapping`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}



export async function DeleteMilestoneMaster(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Project/DeleteMilestoneMaster`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}